<div class="card  text-center" style="direction: ltr;min-height: 700px;">
    <br>

    <div *ngIf="result == 'success'">
    <i class="lar la-check-circle" style="font-size: 106px;
    color: #0cb10c;
    margin-bottom: 12px;"></i>
    <br>  <h5>Payment Successful</h5>

    <div><p style="  ">Thank you for completing your order</p></div>
    <div class="row">
        <div class="col-12 text-center">
            <table style="width: 400px;"  class="text-left payment-result-table  table-striped table-condensed">

                <tr>
                    <td><b>Order ID</b></td>
                    <td>{{order_id}}</td>
                </tr>  <tr>
                    <td><b>Tarnsaction ID</b></td>
                    <td>{{transaction_id}}</td>
                </tr>

                <tr>
                    <td><b>Amount</b></td>
                    <td>{{amt}} KWD</td>
                </tr>

            </table>
        </div>

    </div>
    <br>
    <a class="btn btn-primary ml-auto mr-auto" style="" [routerLink]="'/'">Home</a>
    </div>

    <div *ngIf="result == 'failure'">
        <i class="lar la-times-circle" style="font-size: 106px;
    color: #990000;
    margin-bottom: 12px;"></i>
        <br>  <h5>Payment Failed</h5>

        <div><p style="  ">Something wrong went with your payment, please contact your bank for more details.</p></div>
        <br>
        <a class="btn btn-primary ml-auto mr-auto" style="" [routerLink]="'/'">Home</a>
    </div>


</div>